import React from 'react';
import {
  FaChevronDown,
  FaChevronUp,
  FaPlus,
  FaLock,
  FaEye,
  FaEdit,
} from 'react-icons/fa';
import { canOpenFolder } from '../../utils/permissions';
import { getStoredAuthUser, isUniverseAdmin } from '../../utils/auth';
import { NavigationView } from './navigation.View';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setDrawerOpen, setOpenModales } from '../../store/global'; // Import de setOpenModales
import { BtnSimple } from '../form/btn.Simple';
import { LinkNew } from '../link/link.New'; // Import de LinkNew

export const NavigationFolder = props => {
  const { folder: folderProp, isAdminOfUniverse = false } = props;

  const [collapsed, setCollapsed] = React.useState(true);
  const dispatch = useDispatch();
  // Important: `folder` is often coming from a cached list (fetched once).
  // Read the canonical item from redux so UI updates immediately after settings changes.
  const folder = useSelector(state => state.items[folderProp?._id] || folderProp);
  const universe = useSelector(state => state.items[folder?.universe]);
  const relatedItems = useSelector(
    state => {
      const mapped = {};
      const ids = [folder?._id, folder?.universe].filter(Boolean);
      ids.forEach(id => {
        if (state.items[id]) {
          mapped[id] = state.items[id];
        }
      });
      return mapped;
    },
    shallowEqual
  );
  const authUser = getStoredAuthUser();
  const authUserId = authUser?._id;
  const derivedIsAdmin =
    isAdminOfUniverse || isUniverseAdmin(universe, authUserId);
  const canAccessFolder = canOpenFolder({
    folder,
    universe,
    items: relatedItems,
    isAdminOfUniverse: derivedIsAdmin,
  });

  return (
    <div>
      <div
        className={`sticky top-0 z-10 backdrop-blur-md bg-main bg-opacity-50 flex items-center gap-1 transition cursor-pointer px-05 py-05`}
        onClick={() => setCollapsed(!collapsed)}
      >
        {!collapsed ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        <div
          onClick={() => {
            if (canAccessFolder) {
              dispatch(setDrawerOpen(folder?._id));
            } else {
              setCollapsed(!collapsed);
            }
          }}
          className='flex-1 font-condensed uppercase text-sm flex gap-05'
        >
          {(() => {
            const visibility = folder?.access?.visibility || 'public';
            const defaultRole = folder?.access?.defaultRole || 'editor';
            if (folder?.password || visibility === 'private') {
              return <FaLock />;
            }
            if (visibility === 'public') {
              return defaultRole === 'editor' ? <FaEdit /> : <FaEye />;
            }
            return null;
          })()}{' '}
          {folder.label}
        </div>
      </div>
      {!collapsed && canAccessFolder && (
        <>
          <NavigationView
            inFolder={true}
            parentId={folder?._id}
            viewId={folder?.view}
          />
          <div className='flex gap-1 mt-1 mx-1'>
            <BtnSimple
              className='flex gap-1 items-center bg-main'
              onClick={() =>
                dispatch(
                  setOpenModales({ id: 'addLink' + folder._id, open: true }),
                )
              }
            >
              <FaPlus /> Ajouter un item
            </BtnSimple>
          </div>
        </>
      )}
      <LinkNew
        mode='folder'
        itemId={folder._id}
      />
    </div>
  );
};
